import { NetworkStatus, useMutation, useQuery } from '@apollo/client';
import {  FormControlLabel,Switch } from '@mui/material';
import { format, lastDayOfMonth } from 'date-fns';
import React, { useMemo, useState } from 'react';
import DatePicker from 'react-datepicker';
import { IoCalendarOutline } from 'react-icons/io5';
import {  showToastMessage } from 'src/coach/service/coach.utils';
import { useModal } from 'src/shared/hooks/use-modal';
import BlockLoading from 'src/shared/ui/components/block-loading/block-loading';
import AddAvailability from './addAvailability';
import AvailabilityActions from './components/actions';
import { AvailabilityPeriodList } from './components/availabilty-list';
import { DeleteBulkAvailabilities } from './components/deleteAvailabilityBulk';
import {deleteBulkAvailabilityPeriodMutation } from './graphql/availability-mutation';
import { getAvailabilityPeriods } from './graphql/availability-query';



export const Availability = ({data}) => {
  const coachId = data?.account?.id;
  const today = new Date();
  const firstDateOfMonth = format(today, 'yyyy-MM-01');
  const lastDateOfMonth = format(lastDayOfMonth(today), 'yyyy-MM-dd')

   const [startDate, setStartDate] = useState(firstDateOfMonth);
  const [endDate, setEndDate] = useState(lastDateOfMonth);
  const [showGeneralAvailability, setShowGeneralAvailability] = useState(true);

    const {
    data:availabilityData,
    previousData: previousAvailabilityPeriodData,
    loading:availabilityLoading,
    networkStatus,
    refetch: availabilityPeriodRefetch,
  } = useQuery(getAvailabilityPeriods, {
    fetchPolicy:'network-only',
    notifyOnNetworkStatusChange: true,
    variables: {
      input: {
        coachId: Number(coachId),
        startDate,
        endDate,
        showGeneralAvailability,
      },
    },
  });
  const availabilityPeriodUnsorted = availabilityData?.availabilityPeriodsFranchise || previousAvailabilityPeriodData?.availabilityPeriodsFranchise;
  const availabilityPeriodData = useMemo(() => {
  return [...(availabilityPeriodUnsorted || [])].sort((a, b) => {
    if (a.franchiseId === null) return -1;
    if (b.franchiseId === null) return 1;

    // Sort by franchise name alphabetically
    return a.franchise.name.localeCompare(b.franchise.name);
  });
}, [availabilityPeriodUnsorted]);

  const coachFranchises = useMemo(()=>availabilityPeriodData?.filter(f=>Boolean(f.franchiseId))?.map(item=>item.franchise),[availabilityPeriodData]);

  const noPeriods = availabilityPeriodData?.every(item=>item?.periods?.length === 0);
  const [deleteBulkAvailabilities,{loading:bulkDeleteLoading}] = useMutation(deleteBulkAvailabilityPeriodMutation);
  const { isOpen:isOpenAdd, actions:addActions  } = useModal();
  const {isOpen:isOpenDelete, actions:deleteActions} = useModal();


  const handleBulkDelete = async (payload) => {
    try {
      await deleteBulkAvailabilities({
        variables: {
          input: {
            availabilityPeriodFranchise: payload,
            coachId: Number(coachId),
          },
        },
      });
      await availabilityPeriodRefetch();
      showToastMessage('Availabilities removed successfully');
    } catch {
      showToastMessage('Could not able to remove Availabilities','error');
    }
  }
   const handleToggleGeneralAvailability = () => {
    setShowGeneralAvailability((prev) => !prev);
  }
 return (
  <div className="tw-pb-24">
    <div className="tw-mb-4 tw-flex tw-flex-col tw-bg-white lg:tw-flex-row lg:tw-justify-between lg:tw-items-start tw-gap-4 tw-sticky tw-top-[60px] tw-z-[1]">
      <div className="tw-flex tw-gap-1 tw-flex-col">
        <div className="tw-flex tw-gap-4 sm:tw-gap-2 tw-items-center">
        <div className='tw-w-32 sm:tw-w-auto'>
        <DatePicker
        selected={startDate}
        onChange={(date) => setStartDate(format(date, 'yyyy-MM-dd'))}
        popperClassName={'tw-ml-10'}                      
        customInput={
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              border: '1px solid #ddd',
              borderRadius: '6px',
              padding: '8px 12px',
              fontSize: '16px',
              width: '140px',
              justifyContent: 'space-between',
              cursor: 'pointer',
            }}
            onClick={(e) => e.preventDefault()}
          >
            <input
              style={{
                border: 'none',
                background: 'transparent',
                fontSize: '16px',
                width: '100%',
                padding: 0,
                margin: 0,
                outline: 'none',
              }}
              value={startDate ? startDate: ''}
              readOnly
            />
            <IoCalendarOutline style={{ fontSize: '18px', color: '#000' }} />
          </div>
        }
      />
        </div>
        <div className="tw-text-xs sm:tw-text-base tw-hidden sm:tw-block">To</div>
        <div className='tw-w-32 sm:tw-w-auto'>
          <DatePicker
        selected={startDate}
        onChange={(date) => setEndDate(format(date,'yyyy-MM-dd'))}
        customInput={
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              border: '1px solid #ddd',
              borderRadius: '6px',
              padding: '8px 12px',
              fontSize: '16px',
              width: '140px',
              justifyContent: 'space-between',
              cursor: 'pointer',
            }}
            onClick={(e) => e.preventDefault()}
          >
            <input
              style={{
                border: 'none',
                background: 'transparent',
                fontSize: '16px',
                width: '100%',
                padding: 0,
                margin: 0,
                outline: 'none',
              }}
              value={endDate ? endDate: ''}
              readOnly
            />
            <IoCalendarOutline style={{ fontSize: '18px', color: '#000' }} />
          </div>
        }
      />
          
        </div>
      </div>
        <FormControlLabel
          control={
            <Switch
              checked={showGeneralAvailability}
              onChange={handleToggleGeneralAvailability}
              name="showGeneralAvailability"
              color="primary"
            />
          }
          label="Show General Availability"
        />
      </div>
      <div className="tw-flex tw-justify-end lg:tw-w-auto tw-w-full">
        <AvailabilityActions
          addAvailabilityAction={addActions}
          deleteAvailabilityAction={{ ...deleteActions, disabled: noPeriods }}
        />
      </div>
    </div>

    <BlockLoading loading={ availabilityLoading || networkStatus === NetworkStatus.loading}>
      {noPeriods ? (
        <p className="tw-text-center tw-text-lg tw-mt-4">No availability periods found</p>
      ) : (
        availabilityPeriodData?.map((item) => {
          if (!item?.periods?.length) return null;
          return (
            <div key={item.franchiseId}>
              <p className="tw-font-bold tw-text-lg tw-my-4">{item?.franchise?.name}
                {item?.franchise.id==0 && <p className="tw-font-normal tw-text-sm tw-mb-4">({coachFranchises?.map(f=>f.name)?.join(', ')})</p>}
              </p>
              
              <AvailabilityPeriodList
                franchises={coachFranchises}
                availabilityPeriods={item?.periods}
                refetch={availabilityPeriodRefetch}
                coachId={coachId}
                showActions={item?.franchise?.settings?.canManageAvailability || false}
              />
            </div>
          );
        })
      )}
    </BlockLoading>

    {isOpenAdd && (
      <AddAvailability
        franchises={coachFranchises}
        coachId={coachId}
        actions={addActions}
        title="Add Availability"
        refetch={availabilityPeriodRefetch}
      />
    )}
    {isOpenDelete && (
       <DeleteBulkAvailabilities
        $message={'Select the availability records you would like to remove'}
        $onConfirm={handleBulkDelete}
        $loading={bulkDeleteLoading}
        $actions={deleteActions}
        $title="Remove Availability"
        franchises={coachFranchises}
        coachId={coachId}
      />
    )}
  </div>
);

}